import Error404 from './Error';

export default Error404;
